import React, { useState } from 'react';
import { DillButton, DillModal } from '../../../general/Dill';
import { isHTML } from '../../../../utils/helpers';
import { useWindowActualWidth } from '../../../../utils/domTools';
import { twMerge } from 'tailwind-merge';

const CreditSafeReportModal = ({
  open,
  handleClose,
  details,
  overlayZIndex,
}: {
  open: boolean;
  handleClose: () => void;
  details: any;
  overlayZIndex?: number;
}) => {
  const [loading, setLoading] = useState(false);

  const width = useWindowActualWidth();
  const handleCloseModal = () => {
    setLoading(false);
    handleClose();
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Credit Safe Report"
      maxWidth="66vw"
      overlayZIndex={overlayZIndex}
      footer={
        <div className="flex justify-end w-full">
          <DillButton
            label="Close"
            variant="secondary"
            onClick={handleCloseModal}
            isDisabled={loading}
          />
        </div>
      }>
      <div className={twMerge('flex flex-col', width > 1440 ? 'items-center' : '')}>
        {isHTML(details) ? (
          <div dangerouslySetInnerHTML={{ __html: details }} />
        ) : (
          <p>{JSON.stringify(details)}</p>
        )}
      </div>
    </DillModal>
  );
};

export default CreditSafeReportModal;
